<button mat-icon-button (click)="copyClick()" [id]="buttonName" aria-label="Copy to clipboard"
    matTooltip="Copy to clipboard" matTooltipPosition="right">
    <mat-icon>content_copy</mat-icon>
</button><span matTooltip="Copied" #tooltip="matTooltip" matTooltipPosition="right"></span>